import { BUSINESSES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import businessesTypes from '../../constants/businessesTypes'
import { axios } from '../../services'

//  ACTIVATE AND DEACTIVATE
const activate_business_request = () => {
  return {
    type: businessesTypes.activate.request
  }
}

const activate_business_success = (response) => {
  return {
    type: businessesTypes.activate.success,
    payload: response.data
  }
}

const activate_single_business_success = (response) => {
  return {
    type: businessesTypes.activate.single,
    payload: response.data
  }
}

const activate_business_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: businessesTypes.activate.failure,
    payload: messages
  }
}

const activate_business = (business_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( activate_business_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(BUSINESSES_ROUTES.activate, {id: business_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The business status has changed to: Active.')
      if ( index ) {
        dispatch( activate_business_success(response) )

      } else {
        dispatch( activate_single_business_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error activating business"]
      }
      dispatch( activate_business_failure( errors ) )
    })
  }
}

const deactivate_business = (business_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( activate_business_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(BUSINESSES_ROUTES.deactivate, {id: business_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The business status has changed to: Inactive.')
      if ( index ) {
        dispatch( activate_business_success(response) )

      } else {
        dispatch( activate_single_business_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deactivating business"]
      }
      dispatch( activate_business_failure( errors ) )
    })
  }
}

export {
  activate_business,
  deactivate_business,
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/activate.js